var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMicrosoftLogo = function SvgMicrosoftLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 800,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FEBA08",
    d: "M17 17h10v10H17z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#05A6F0",
    d: "M5 17h10v10H5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#80BC06",
    d: "M17 5h10v10H17z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F25325",
    d: "M5 5h10v10H5z"
  })));
};
export default SvgMicrosoftLogo;